import './not-found.scss';
import { Col, Row } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import Heading from '../../components/heading/heading';

const NotFoundPage: React.FunctionComponent = () => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <Row justify="center" align="middle" className="not-found-container">
                <Col className="text-center">
                    <Heading level={1} className="massive">
                        404
                    </Heading>
                    <Heading level={2} className="massive">
                        {t('errors.notFound')}
                    </Heading>
                </Col>
            </Row>
        </React.Fragment>
    );
};

export default NotFoundPage;
